import { useContext } from 'react';

import { FwModuleStoreContext } from './FwModuleStoreContext';

const useFwModuleStore = () => useContext(FwModuleStoreContext);

export { useFwModuleStore };
